module.exports = __webpack_public_path__ + "assets/img1.ee16484a.jpg";